import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ThemeProvider } from "next-themes";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { DoctorThemeSync } from "@/components/DoctorThemeSync";
import { AuthProvider } from "@/contexts/AuthContext";
import { IntlProvider } from "@/contexts/IntlProvider";
import { UnitSystemProvider } from "@/contexts/UnitSystemContext";
import { QueryProvider } from "@/lib/query-client";
import App from "./App";
import "./app/globals.css";
const root = document.getElementById("root");
if (!root)
    throw new Error("Root element not found");
createRoot(root).render(_jsx(StrictMode, { children: _jsx(BrowserRouter, { children: _jsx(QueryProvider, { children: _jsx(AuthProvider, { children: _jsx(IntlProvider, { children: _jsxs(ThemeProvider, { attribute: "class", defaultTheme: "light", storageKey: "theme", disableTransitionOnChange: true, children: [_jsx(DoctorThemeSync, {}), _jsx(UnitSystemProvider, { children: _jsx(App, {}) })] }) }) }) }) }) }));
